import React, { useState, useContext, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/styles";
import {
  Card,
  Grid,
  Button,
  IconButton,
  Typography,
  TextField,
  Tooltip,
  Switch,
} from "@material-ui/core";
// import MaterialTable from "material-table";
import useReactRouter from "use-react-router";
import {
  // FaSearch,
  FaFileInvoice,
  FaSort,
} from "react-icons/fa";
import { IoIosTrash, IoIosSettings } from "react-icons/io";
import { FiEdit } from "react-icons/fi";
import TableData from "../../Item/TableData";
import { LangContext } from "../../../Context/Langcontext";
import { UserContext } from "../../../Context/UserContext";
import DialogOpen from "../../Item/Dialog";
import { deleteUser, updateUser } from "../../../API/User";
import { useSnackbar } from "notistack";
import FilterUser from "../../Item/filterUser";

const UserSwitch = withStyles((theme) => ({
  root: {
    width: 33,
    height: 17,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#30d126",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#30d126",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 14,
    height: 14,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: "#ff3333",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Tooltip title="เปิด/ปิด การใช้งานของผู้ใช้" placement="top">
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    </Tooltip>
  );
});

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    // height: "100%",
    minHeight: "-webkit-fill-available",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 17.9rem)",
    maxHeight: "100%",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    // marginTop: "1rem",
    "&:hover": {
      background: "#e16733",

      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  grid: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  image: {
    width: "auto",
    height: "1.5rem",
  },
  tool: {
    height: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  deltext: {
    fontWeight: 200,
    fontSize: "1rem",
    marginBottom: 10,
  },
  inputStyle: {
    fontWeight: 200,
    fontSize: "1rem",
  },
}));

const Useradmin = ({ create, setCreate }) => {
  const classes = useStyle();
  const { enqueueSnackbar } = useSnackbar();
  const { history } = useReactRouter();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const userContext = useContext(UserContext);
  const userlist = userContext.data;
  const userInfo = userContext.state;
  const [userData, setUserData] = useState(userlist);
  const [duser, setDuser] = useState(true);
  const [del, setdel] = useState(false);
  const [state, setstate] = useState({
    confirmname: "",
    id: "",
    checkname: "",
  });
  const [error, setError] = useState({
    statusconfirm: false,
    confirmname: "",
  });

  const columns = [
    {
      title: lang.No,
      field: "no",
      width: "10px",
      sorting: false,
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: `${lang.Name} - ${lang.Lastname}`,
      field: "name",
      sorting: false,
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: lang.Organization,
      field: "organization",
      sorting: false,
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
      headerStyle: {
        textAlign: "left",
      },
    },
    {
      title: lang.Type,
      field: "type",
      sorting: false,
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
      headerStyle: {
        textAlign: "left",
      },
    },
    {
      title: lang.Contract,
      field: "contract",
      sorting: false,
      cellStyle: {
        textAlign: "center",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: lang.Status,
      field: "status",
      sorting: false,
      cellStyle: {
        textAlign: "center",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: <IoIosSettings size={20} />,
      sorting: false,
      field: "tool",
    },
  ];

  const convertDate = (date) => {
    let day = date.substring(8, 10);
    let month = date.substring(5, 7);
    let year = date.substring(0, 4);
    return `${day}/${month}/${
      langContext.lang.locale === "th" ? Number(Number(year) + 543) : year
    }`;
  };

  const onEnabled = async (id) => {
    let udata = [...userData];
    let index = udata
      .map((rs) => {
        return rs._id;
      })
      .indexOf(id);
    udata[index].enabled = !udata[index].enabled;
    setUserData(udata);
    const update = await updateUser(id, udata[index]);
    if (update.status.code === 200) {
      if (udata[index].enabled) {
        enqueueSnackbar(lang.EnableUser, {
          variant: "success",
        });
      } else {
        enqueueSnackbar(lang.DisableUser, {
          variant: "success",
        });
      }
    } else {
      enqueueSnackbar("มีบางอย่างผิดพลาด", {
        variant: "error",
      });
    }
  };

  const showOrganization = (org) => {
    if (org.organization) {
      return org.organization;
    } else if (org.mea) {
      return "MEA";
    } else {
      return "-";
    }
  };

  const Rows = userData
    .filter((u) => {
      return userInfo.role === "admin" || userInfo.role === "root"
        ? u.role !== "root"
        : u.role !== "admin" && u.role !== "root";
    })
    .map((rs, index) => {
      return {
        no: index + 1,
        name: `${rs.first_name} ${rs.last_name}`,
        organization: showOrganization(rs),
        type: `${rs.role.split("_").join(" ").charAt(0).toUpperCase()}${rs.role
          .split("_")
          .join(" ")
          .slice(1)}`,
        contract:
          rs.contract !== undefined
            ? `${convertDate(rs.contract.start_date)} - ${convertDate(
                rs.contract.end_date
              )}`
            : "-",

        status: (
          <div>
            <UserSwitch
              checked={rs.enabled}
              name={`${rs._id}`}
              onChange={() => {
                onEnabled(rs._id);
              }}
            />
          </div>
        ),
        tool: (
          <div className={classes.tool}>
            <Tooltip title={lang.Edit} placement="top">
              <IconButton
                onClick={() => {
                  history.push(`/app/useradmin/user/${rs._id}-null`);
                }}
              >
                <FiEdit size={18} />
              </IconButton>
            </Tooltip>

            <Tooltip title={lang.Delete} placement="top">
              <IconButton
                onClick={() => {
                  setdel(true);
                  setstate({
                    ...state,
                    checkname: `${rs.first_name} ${rs.last_name}`,
                    id: rs._id,
                  });
                }}
              >
                <IoIosTrash size={22} />
              </IconButton>
            </Tooltip>

            {rs.role === "contract" ? (
              <Tooltip title={lang.Invoice} placement="top">
                <IconButton
                  onClick={() => {
                    history.push(`/app/useradmin/invoice/${rs._id}`);
                  }}
                >
                  <FaFileInvoice size={18} />
                </IconButton>
              </Tooltip>
            ) : null}
          </div>
        ),
      };
    });

  const delUser = async (e) => {
    e.preventDefault();
    if (state.confirmname !== state.checkname) {
      setError({ ...error, statusconfirm: true, confirmname: "not matched" });
    } else {
      const remove = await deleteUser(state.id);
      setDuser(true);
      if (!remove.status) {
        setDuser(true);
        let userdata = [...userlist];
        let index = userdata
          .map((rs) => {
            return rs._id;
          })
          .indexOf(state.id);

        userdata.splice(index, 1);

        userContext.setData(userdata);

        setstate({ ...state, confirmname: "" });
        enqueueSnackbar(lang.Deleteusersuccess, {
          variant: "success",
        });
        setdel(false);
      } else {
        enqueueSnackbar(lang.Cannotdeleteuser, {
          variant: "error",
        });
      }
    }
  };

  useEffect(() => {
    setUserData(userlist);
  }, [userlist]);

  return (
    <div className={classes.root}>
      <Card className={classes.cardapi}>
        <Grid container spacing={0}>
          <Grid item md={5} sm={12} xs={12}>
            <div style={{ margin: "2rem 2rem 0rem 2rem" }}>
              <FilterUser setUserData={setUserData} />
            </div>
          </Grid>
          <Grid item md={7} sm={12} xs={12} className={classes.grid}>
            <div style={{ margin: "2rem 2rem 0rem 2rem" }}>
              <Tooltip title="คลิกเพื่อเพิ่มผู้ใช้" placement="top">
                <Button
                  className={classes.btnstyle}
                  onClick={() => {
                    history.push("/app/useradmin/user/add-null");
                  }}
                >
                  {lang.CreateUser}
                </Button>
              </Tooltip>
            </div>
          </Grid>

          <TableData
            columns={columns}
            data={Rows}
            Iconsort={React.forwardRef((props, ref) => (
              <FaSort {...props} ref={ref} />
            ))}
          />
        </Grid>
      </Card>
      <DialogOpen
        type={"delete"}
        open={del}
        genapi={delUser}
        handleClose={() => {
          setdel(false);
        }}
        header={`${lang.DeleteUser} ? `}
        update={duser}
      >
        <Typography className={classes.deltext}>
          {lang.ConfirmNameUser}
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          required
          label={`${lang.Name} ${lang.Lastname}`}
          fullWidth
          value={state.confirmname}
          onChange={(e) => {
            setstate({ ...state, confirmname: e.target.value });
            setDuser(false);
            setError({ ...error, statusconfirm: false, confirmname: "" });
          }}
          className={classes.textfield}
          inputProps={{
            className: classes.inputStyle,
          }}
          InputLabelProps={{
            className: classes.inputLabelStyle,
          }}
          error={error.statusconfirm}
          helperText={error.confirmname}
        />
      </DialogOpen>
    </div>
  );
};

export default Useradmin;
